import React from "react";

function GeneralIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clip-path="url(#clip0_1388_2161)">
        <path
          d="M12.4688 12.0063C11.7781 10.8063 10.4812 10 9 10H7C5.51875 10 4.22188 10.8063 3.53125 12.0063C4.63125 13.2313 6.225 14 8 14C9.775 14 11.3687 13.2281 12.4688 12.0063ZM0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8ZM8 8.5C8.59674 8.5 9.16903 8.26295 9.59099 7.84099C10.0129 7.41903 10.25 6.84674 10.25 6.25C10.25 5.65326 10.0129 5.08097 9.59099 4.65901C9.16903 4.23705 8.59674 4 8 4C7.40326 4 6.83097 4.23705 6.40901 4.65901C5.98705 5.08097 5.75 5.65326 5.75 6.25C5.75 6.84674 5.98705 7.41903 6.40901 7.84099C6.83097 8.26295 7.40326 8.5 8 8.5Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1388_2161">
          <path d="M0 0H16V16H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default GeneralIcon;
